import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { generateUrls, useRelations } from '@hooks/useUser'

import type { UserModel } from '@domain-group/realhub-backend-api-types'

type UserListItemProps = {
  user: UserModel,
}

const UserListItem = (props: UserListItemProps) => {
  const { user, user: { email, full_name, mobile_number } } = props

  const { editUserUrl } = generateUrls(user)

  const { role } = useRelations(user)

  return (
    <DashboardModuleListItem
      secondaryText={email}
      title={full_name}
    >
      <Box alignItems="end" display={['none', 'flex']} flexDirection="column">
        <Text>{mobile_number}</Text>

        {/*
         // @ts-expect-error TS2339 */}
        {role?.title && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            {/*
             // @ts-expect-error TS2339 */}
            {role.title}
          </Text>
        )}
      </Box>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editUserUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default UserListItem
